import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { PriceInput } from 'site-modules/lease-deals/components/price-input/price-input';

export function NumericController({
  name,
  labelText,
  max,
  adornment = null,
  validateRules = undefined,
  trackingId = undefined,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors[name];
  const errorId = `${name}-error`;

  return (
    <div>
      <Controller
        name={name}
        control={control}
        rules={validateRules}

        render={({ field: { ref, ...restField } }) => (
          <PriceInput
            {...restField}
            min={0}
            max={max}
            labelText={labelText}
            startAdornment={adornment && <span className="size-16 text-cool-gray-40 me-0_25">{adornment}</span>}
            aria-invalid={!!error}
            aria-describedby={error ? errorId : undefined}
            data-tracking-id={trackingId}
          />
        )}
      />
      {error && (
        <span id={errorId} role="alert" className="size-12 text-red-50 mt-0_25">
          {error.message}
        </span>
      )}
    </div>
  );
}

NumericController.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  max: PropTypes.number.isRequired,
  adornment: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  validateRules: PropTypes.shape({}),
  trackingId: PropTypes.string,
};
